import React, { useEffect, useState } from 'react';
import { ArrowLeft2, ArrowRight2 } from 'iconsax-react';
import { TIPO, apiToViewEvento, toDayRange } from './mockData';

const GIORNI = ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'];
const MESI   = ['gennaio','febbraio','marzo','aprile','maggio','giugno','luglio','agosto','settembre','ottobre','novembre','dicembre'];

function IconLista({ active }) {
    const c = active ? '#FF5E4B' : '#bbb';
    return <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><rect x="3" y="5" width="18" height="3" rx="1" fill={c}/><rect x="3" y="11" width="18" height="3" rx="1" fill={c}/><rect x="3" y="17" width="18" height="3" rx="1" fill={c}/></svg>;
}
function IconTimeline({ active }) {
    const c = active ? '#FF5E4B' : '#bbb';
    return <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><rect x="3" y="5" width="8" height="3" rx="1" fill={c}/><rect x="3" y="11" width="14" height="3" rx="1" fill={c}/><rect x="3" y="17" width="5" height="3" rx="1" fill={c}/></svg>;
}

function PagatoBadge({ pagato }) {
    if (pagato) return <span style={{ fontSize: 11, fontWeight: 600, background: '#00A15D', color: '#fff', borderRadius: 3, padding: '2px 8px', whiteSpace: 'nowrap' }}>Pagato</span>;
    return <span style={{ fontSize: 11, fontWeight: 600, background: 'rgba(255,94,75,0.08)', color: '#FF5E4B', border: '1px solid rgba(255,94,75,0.35)', borderRadius: 3, padding: '2px 8px', whiteSpace: 'nowrap' }}>Non pagato</span>;
}

function GiornoHeader({ date, subView, setSubView, onNav }) {
    const label = `${GIORNI[date.getDay()]} ${date.getDate()} ${MESI[date.getMonth()]} ${date.getFullYear()}`;
    const btnBase = { width: 30, height: 30, display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #e0e0e0', borderRadius: 4, background: '#fff', cursor: 'pointer' };
    const toggleBase = { width: 30, height: 30, display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #e0e0e0', cursor: 'pointer' };
    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 24px', borderBottom: '1px solid #f0f0f0', flexWrap: 'wrap', gap: 8, flexShrink: 0 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 18, flexWrap: 'wrap' }}>
                <span style={{ fontSize: 17, fontWeight: 700, color: '#222' }}>{label}</span>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    {Object.entries(TIPO).map(([k, t]) => (
                        <span key={k} style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 12, color: '#555' }}>
                            <span style={{ width: 8, height: 8, borderRadius: '50%', background: t.color, display: 'inline-block' }} />
                            {t.label}
                        </span>
                    ))}
                </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <div style={{ display: 'flex', border: '1px solid #e0e0e0', borderRadius: 4, overflow: 'hidden' }}>
                    <button onClick={() => setSubView('lista')}    style={{ ...toggleBase, background: subView === 'lista'    ? '#FFF0EE' : '#fff', borderRight: '1px solid #e0e0e0', borderRadius: 0 }}><IconLista    active={subView === 'lista'}    /></button>
                    <button onClick={() => setSubView('timeline')} style={{ ...toggleBase, background: subView === 'timeline' ? '#FFF0EE' : '#fff', borderRadius: 0 }}><IconTimeline active={subView === 'timeline'} /></button>
                </div>
                <button onClick={() => onNav(-1)} style={btnBase}><ArrowLeft2  size={14} color="#555" /></button>
                <button onClick={() => onNav(1)}  style={btnBase}><ArrowRight2 size={14} color="#555" /></button>
            </div>
        </div>
    );
}

const MAX_VISIBLE = 4;

function ListaEventCard({ event, onEventClick }) {
    const t = TIPO[event.type] || TIPO.generico;
    return (
        <div onClick={() => onEventClick && onEventClick(event)}
            style={{ background: '#fff', borderLeft: `4px solid ${t.color}`, borderRadius: '0 4px 4px 0', boxShadow: '0 1px 4px rgba(0,0,0,0.07)', padding: '8px 12px', minWidth: 180, maxWidth: 240, cursor: 'pointer', transition: 'box-shadow 0.15s', flexShrink: 0 }}
            onMouseEnter={e => e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.12)'}
            onMouseLeave={e => e.currentTarget.style.boxShadow = '0 1px 4px rgba(0,0,0,0.07)'}
        >
            <div style={{ fontSize: 13, fontWeight: 700, color: '#1a1a1a', marginBottom: 3, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{event.titolo}</div>
            <div style={{ fontSize: 11, color: '#999', marginBottom: 7 }}>{event.oraInizio} – {event.oraFine}</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 5, flexWrap: 'wrap' }}>
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 11, color: '#aaa', border: '1px solid #e8e8e8', borderRadius: 3, padding: '1px 6px', background: '#fafafa' }}>
                    <span style={{ width: 7, height: 7, borderRadius: '50%', border: '1.5px solid #ccc', display: 'inline-block', flexShrink: 0 }} />{event.type === 'generico' ? 'Generico' : (event.tipologia || '—')}
                </span>
                {event.type !== 'generico' && <PagatoBadge pagato={event.pagato} />}
            </div>
        </div>
    );
}

function ListaRow({ ora, eventi, onEventClick, onOraClick }) {
    const [expanded, setExpanded] = useState(false);
    const visible  = expanded ? eventi : eventi.slice(0, MAX_VISIBLE);
    const overflow = eventi.length - MAX_VISIBLE;
    return (
        <div style={{ display: 'flex', gap: 0, minHeight: 56, borderBottom: '1px solid #f4f4f4' }}>
            <div
                onClick={() => onOraClick && onOraClick(ora)}
                title={onOraClick ? "Vai alla vista ora" : undefined}
                style={{ width: 64, flexShrink: 0, paddingTop: 12, paddingRight: 16, textAlign: 'right', fontSize: 13, fontWeight: 600, color: '#aaa', cursor: onOraClick ? 'pointer' : 'default' }}
            >{ora}</div>
            <div style={{ width: 1, background: '#f0f0f0', flexShrink: 0 }} />
            <div style={{ flex: 1, display: 'flex', flexWrap: 'wrap', gap: 8, padding: '10px 16px', alignItems: 'flex-start' }}>
                {visible.map(ev => <ListaEventCard key={ev.id} event={ev} onEventClick={onEventClick} />)}
                {!expanded && overflow > 0 && (
                    <button onClick={() => setExpanded(true)} style={{ alignSelf: 'center', background: '#FF5E4B', color: '#fff', border: 'none', borderRadius: 4, fontSize: 12, fontWeight: 700, padding: '4px 10px', cursor: 'pointer', whiteSpace: 'nowrap' }}>+{overflow}</button>
                )}
            </div>
        </div>
    );
}

function ListaView({ eventi, onEventClick, onOraClick }) {
    const grouped = {};
    eventi.forEach(ev => {
        if (!grouped[ev.oraInizio]) grouped[ev.oraInizio] = [];
        grouped[ev.oraInizio].push(ev);
    });
    const ore = Object.keys(grouped).sort();
    if (ore.length === 0) return <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#ccc', fontSize: 14 }}>Nessun evento per questo giorno</div>;
    return (
        <div style={{ flex: 1, overflowY: 'auto' }}>
            {ore.map(ora => <ListaRow key={ora} ora={ora} eventi={grouped[ora]} onEventClick={onEventClick} onOraClick={onOraClick} />)}
        </div>
    );
}

const PX_PER_MIN = 2.5;
const T_START_H  = 6;
const T_END_H    = 23;
const STEP_MIN   = 30;
const LABEL_W    = 56;

function timeToMinutes(t) { const [h, m] = t.split(':').map(Number); return h * 60 + m; }

function TimelineView({ eventi, onEventClick, onOraClick }) {
    let startMin = T_START_H * 60;
    let endMin   = T_END_H   * 60;

    // Espandi il range per includere tutti gli eventi
    eventi.forEach(ev => {
        const s = timeToMinutes(ev.oraInizio);
        const e = timeToMinutes(ev.oraFine);
        if (s < startMin) startMin = Math.max(0, Math.floor(s / 60) * 60);
        if (e > endMin)   endMin   = Math.min(24 * 60, Math.ceil(e / 60) * 60);
    });

    const totalPx  = (endMin - startMin) * PX_PER_MIN;

    const labels = [];
    for (let m = startMin; m <= endMin; m += STEP_MIN) {
        const hh = String(Math.floor(m / 60)).padStart(2, '0');
        const mm = String(m % 60).padStart(2, '0');
        labels.push({ label: `${hh}:${mm}`, offset: (m - startMin) * PX_PER_MIN });
    }

    const rows = [
        { key: 'impianto', label: 'Impianti',        items: eventi.filter(e => e.type === 'impianto') },
        { key: 'lezione',  label: 'Lezioni',         items: eventi.filter(e => e.type === 'lezione')  },
        { key: 'corso',    label: 'Corsi e squadre', items: eventi.filter(e => e.type === 'corso')    },
        { key: 'generico', label: 'Generici',        items: eventi.filter(e => e.type === 'generico') },
    ].filter(r => r.items.length > 0);

    return (
        <div style={{ flex: 1, overflowX: 'auto', overflowY: 'auto' }}>
            <div style={{ minWidth: LABEL_W + totalPx + 24 }}>
                <div style={{ display: 'flex', borderBottom: '1px solid #f0f0f0', paddingBottom: 6, paddingTop: 12 }}>
                    <div style={{ width: LABEL_W + 16, flexShrink: 0 }} />
                    <div style={{ position: 'relative', height: 18, flex: 1 }}>
                        {labels.map((l, i) => (
                            <span
                                key={i}
                                onClick={() => onOraClick && onOraClick(l.label)}
                                title={onOraClick ? "Vai alla vista ora" : undefined}
                                style={{ position: 'absolute', left: l.offset, transform: 'translateX(-50%)', fontSize: 11, color: '#bbb', fontWeight: 500, whiteSpace: 'nowrap', cursor: onOraClick ? 'pointer' : 'default' }}
                            >{l.label}</span>
                        ))}
                    </div>
                </div>
                {rows.map((row, ri) => {
                    const t = TIPO[row.key];
                    return (
                        <div key={row.key} style={{ display: 'flex', alignItems: 'stretch', borderBottom: ri < rows.length - 1 ? '1px solid #f4f4f4' : 'none', minHeight: 64 }}>
                            <div style={{ width: LABEL_W + 16, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '8px 0' }}>
                                <span style={{ writingMode: 'vertical-rl', transform: 'rotate(180deg)', fontSize: 11, fontWeight: 700, color: t.color, letterSpacing: 0.5, whiteSpace: 'nowrap' }}>{row.label}</span>
                            </div>
                            <div style={{ position: 'relative', flex: 1, margin: '8px 0' }}>
                                {labels.map((l, i) => <div key={i} style={{ position: 'absolute', left: l.offset, top: 0, bottom: 0, width: 1, background: '#f4f4f4' }} />)}
                                {row.items.map(ev => {
                                    const evStart = timeToMinutes(ev.oraInizio);
                                    const evEnd   = timeToMinutes(ev.oraFine);
                                    const left    = (evStart - startMin) * PX_PER_MIN;
                                    const width   = Math.max((evEnd - evStart) * PX_PER_MIN - 4, 40);
                                    if (evStart >= endMin || evEnd <= startMin) return null;
                                    return (
                                        <div key={ev.id} onClick={() => onEventClick && onEventClick(ev)}
                                            title={`${ev.titolo} ${ev.oraInizio}–${ev.oraFine}`}
                                            style={{ position: 'absolute', left, width, top: 4, bottom: 4, background: t.bg, borderLeft: `3px solid ${t.color}`, borderRadius: '0 4px 4px 0', display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '2px 6px', cursor: 'pointer', overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}
                                        >
                                            <div style={{ fontSize: 11, fontWeight: 700, color: t.color, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{ev.titolo}</div>
                                            <div style={{ fontSize: 10, color: '#aaa', whiteSpace: 'nowrap' }}>{ev.oraInizio}–{ev.oraFine}</div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default function VistaGiorno({ eventi = [], selectedDate, onDateChange, onRangeChange, onEventClick, onOraClick }) {
    const [subView, setSubView] = useState('lista');

    const date = selectedDate || new Date();

    useEffect(() => {
        const { da, a } = toDayRange(date);
        onRangeChange && onRangeChange(da, a);
    }, [date]); // eslint-disable-line react-hooks/exhaustive-deps

    const onNav = (dir) => {
        const d = new Date(date);
        d.setDate(d.getDate() + dir);
        onDateChange && onDateChange(d);
    };

    // Filtra eventi del giorno selezionato e trasformali
    const dateStr = toDayRange(date).da.substring(0, 10);
    const eventiGiorno = eventi
        .filter(ev => ev.dataInizio.substring(0, 10) === dateStr)
        .map(apiToViewEvento);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <GiornoHeader date={date} subView={subView} setSubView={setSubView} onNav={onNav} />
            {subView === 'lista'    && <ListaView    eventi={eventiGiorno} onEventClick={onEventClick} onOraClick={onOraClick} />}
            {subView === 'timeline' && <TimelineView eventi={eventiGiorno} onEventClick={onEventClick} onOraClick={onOraClick} />}
        </div>
    );
}
